<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <image-list :display-list="displayList" @click="clickOptions" />
    <ul
      v-if="chat.message_rich.hotels && chat.message_rich.hotels.length > hotelsLimit"
      class="chat-message__actions"
    >
      <template v-for="(action, index) in chat.message_rich.actions">
        <action
          :action="action"
          :index="index"
          :check-action-state="checkActionState"
          :click-action="clickAction"
        />
      </template>
    </ul>
  </chat-message>
</template>

<script>
import { formatChatMessage } from 'Utilities'
import Action from './Action.vue'
import ImageList from 'UtilityComponents/ImageList.vue'
import ChatMessage from 'Chats/ChatMessage'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'
import { useDetailsPageStore } from 'Store/details-page'
import { useChatStore } from 'Store/chat'
const defaultLimit = 4

export default {
  components: {
    ChatMessage,
    Action,
    ImageList
  },
  mixins: [chatWidgetMixin],

  setup() {
    return {
      detailsPageStore: useDetailsPageStore(),
      chatStore: useChatStore()
    }
  },

  data: function () {
    return {
      active: this.chat.message_rich.hasOwnProperty('active')
        ? this.chat.message_rich.active
        : true,
      actions: this.chat.message_rich.actions
    }
  },
  computed: {
    formatChatMessage() {
      return formatChatMessage(this.chat.message_rich.message)
    },
    displayList() {
      const { hotels = [] } = this.chat.message_rich
      return hotels.slice(0, this.hotelsLimit)
    },
    hotelsLimit() {
      return this.chat.message_rich.hotels_limit || defaultLimit
    }
  },
  methods: {
    clickOptions(hotel) {
      const messageRich = this.chat.message_rich
      const options = {
        action: messageRich.hotel_select_action,
        paramName: messageRich.hotel_select_action_param_name,
        paramValue: messageRich.hotel_select_action_param_value
      }
      this.chatStore.changeChat(hotel.code, options)
    },
    clickAction(action) {
      this.detailsPageStore.setDetailsPageShown('ImageListSelector')
      this.detailsPageStore.setPageChat(this.chat)
    },
    checkActionState(index) {
      if (this.actions[index].selected === true) {
        return 'choosen'
      }
      if (this.active === false) {
        return 'inactive'
      } else {
        return ''
      }
    }
  }
}
</script>
